/** Os marcadores `$$$nome$$$` que um texto de prompt usa, sem repetição,
 *  na ordem em que aparecem — a tela mostra o que vai ser preenchido na
 *  hora (Administração → Prompts padrão e Ajustes → Configuração de
 *  prompt). */
export function promptMarkers(text: string): string[] {
  const found: string[] = [];
  for (const match of text.matchAll(/\$\$\$([A-Za-z0-9_]+)\$\$\$/g)) {
    if (!found.includes(match[1])) found.push(match[1]);
  }
  return found;
}
